export default __webpack_public_path__ + "static/media/KU.921fb414.svg";